import { useCallback, useEffect, useState } from "react";
import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { useSpace } from "@/context/SpaceContext";

const Pic = ({ item, label }) => (
  <figure className="dup-pic">
    {item?.thumb_url ? <img src={mediaUrl(item.thumb_url)} alt="" loading="lazy" /> : <span />}
    <figcaption>{label}</figcaption>
  </figure>
);

export default function DuplicatesPage() {
  const { space, version } = useSpace();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/duplicates", { params: { space } }).then((r) => setData(r.data)), [space]);
  useEffect(() => { load(); }, [load, version]);

  const act = async (fn, msg) => {
    try {
      await fn();
      toast(msg);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="duplicates-page">
      <div className="view-toolbar"><span className="tool-note" data-testid="duplicates-total">Hidden duplicates · {data?.total ?? "…"}</span></div>
      <div className="dup-grid">
        {data?.pairs.map(({ duplicate: d, original: o }) => (
          <div key={d.id} className="dup-pair" data-testid={`duplicate-pair-${d.id}`}>
            <div className="dup-pics">
              <Pic item={d} label="Hidden" />
              <Pic item={o} label="Kept" />
            </div>
            <div className="dup-actions">
              <button className="tool-btn" onClick={() => act(() => api.post(`/items/${d.id}/restore`), "Restored to library")} data-testid={`duplicate-restore-button-${d.id}`}>
                <RotateCcw size={15} /> <span>Restore</span>
              </button>
              {d.can_delete && (
                <button className="tool-btn" onClick={() => act(() => api.delete(`/items/${d.id}`), "Deleted")} data-testid={`duplicate-delete-button-${d.id}`}>
                  <Trash2 size={15} /> <span>Delete</span>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {data && !data.pairs.length && <div className="book-empty" data-testid="duplicates-empty">No hidden duplicates in this space.</div>}
    </div>
  );
}
